"use strict";

var _regeneratorRuntime = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/circleci/project/packages/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StarkWareProvider = function StarkWareProvider(authereum) {
  var _this = this;

  _classCallCheck(this, StarkWareProvider);

  this.send = function (method, params) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.authereum._postMessageToChild({
                method: 'providerRpc',
                params: {
                  method: method,
                  params: params
                }
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  this.getStarkKey = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkAccount'
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  this.getPublicKey = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkPublicKey'
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  this.getEthAddress = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkEthAddress'
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));
  };

  this.signNonce = function (nonce) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkSignNonce',
                params: {
                  nonce: nonce
                }
              }));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));
  };

  this.starkSignMessage = function (message) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkSignMessage',
                params: {
                  message: message
                }
              }));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));
  };

  this.setContractAddress = function (contractAddress) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkContractAddress',
                params: {
                  contractAddress: contractAddress
                }
              }));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));
  };

  this.getContractAddress = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkContractAddress'
              }));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));
  };

  this.registerUser = function (ethKey, operatorSignature) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkRegisterUser',
                params: {
                  ethKey: ethKey,
                  operatorSignature: operatorSignature
                }
              }));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));
  };

  this.deposit = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDeposit',
                params: input
              }));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));
  };

  this.depositEth = function (vaultId, amount, quantum) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.deposit({
                vaultId: vaultId,
                amount: amount,
                assetStandard: 'ETH',
                quantum: quantum
              }));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));
  };

  this.depositErc20 = function (vaultId, amount, quantum, token) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.deposit({
                vaultId: vaultId,
                amount: amount,
                assetStandard: 'ERC20',
                quantum: quantum,
                assetContractAddress: token
              }));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));
  };

  this.depositErc721 = function (vaultId, tokenId, token) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.deposit({
                vaultId: vaultId,
                amount: tokenId,
                assetStandard: 'ERC721',
                assetContractAddress: token
              }));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));
  };

  this.cancelDeposit = function (vaultId, assetType) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositCancel',
                params: {
                  assetType: assetType,
                  vaultId: vaultId
                }
              }));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));
  };

  this.cancelEthDeposit = function (vaultId, quantum) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositCancel',
                params: {
                  vaultId: vaultId,
                  quantum: quantum,
                  assetStandard: 'ETH'
                }
              }));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, this);
    }));
  };

  this.cancelErc20Deposit = function (vaultId, quantum, token) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositCancel',
                params: {
                  vaultId: vaultId,
                  quantum: quantum,
                  token: token,
                  assetStandard: 'ERC20'
                }
              }));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, this);
    }));
  };

  this.cancelErc721Deposit = function (vaultId, tokenId, token) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositCancel',
                params: {
                  vaultId: vaultId,
                  tokenId: tokenId,
                  token: token,
                  assetStandard: 'ERC721'
                }
              }));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, this);
    }));
  };

  this.reclaimDeposit = function (vaultId, assetType) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositReclaim',
                params: {
                  assetType: assetType,
                  vaultId: vaultId
                }
              }));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, this);
    }));
  };

  this.reclaimEthDeposit = function (vaultId, quantum) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositReclaim',
                params: {
                  vaultId: vaultId,
                  quantum: quantum,
                  assetStandard: 'ETH'
                }
              }));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, this);
    }));
  };

  this.reclaimErc20Deposit = function (vaultId, quantum, token) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositReclaim',
                params: {
                  vaultId: vaultId,
                  quantum: quantum,
                  token: token,
                  assetStandard: 'ERC20'
                }
              }));

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, this);
    }));
  };

  this.reclaimErc721Deposit = function (vaultId, tokenId, token) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
      return _regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkDepositReclaim',
                params: {
                  vaultId: vaultId,
                  tokenId: tokenId,
                  token: token,
                  assetStandard: 'ERC721'
                }
              }));

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, this);
    }));
  };

  this.withdraw = function (assetStandard) {
    var quantum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
    var assetContractAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var recipient = arguments.length > 3 ? arguments[3] : undefined;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
      return _regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkWithdrawTo',
                params: {
                  assetStandard: assetStandard,
                  quantum: quantum,
                  assetContractAddress: assetContractAddress,
                  recipient: recipient
                }
              }));

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, this);
    }));
  };

  this.withdrawEth = function (quantum, recipient) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", this.withdraw('ETH', quantum, null, recipient));

            case 1:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, this);
    }));
  };

  this.withdrawErc20 = function (quantum, token, recipient) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              return _context24.abrupt("return", this.withdraw('ERC20', quantum, token, recipient));

            case 1:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, this);
    }));
  };

  this.withdrawErc721 = function (tokenId, token, recipient) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
      return _regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              return _context25.abrupt("return", this.withdraw('ERC721', tokenId, token, recipient));

            case 1:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, this);
    }));
  };

  this.fullWithdrawalRequest = function (vaultId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              return _context26.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkFullWithdrawalRequest',
                params: {
                  vaultId: vaultId
                }
              }));

            case 1:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, this);
    }));
  };

  this.withdrawAndMint = function (assetType, mintingBlob) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
      return _regeneratorRuntime.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              return _context27.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkWithdrawAndMint',
                params: {
                  assetType: assetType,
                  mintingBlob: mintingBlob
                }
              }));

            case 1:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27, this);
    }));
  };

  this.freezeRequest = function (vaultId) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              return _context28.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkFreezeRequest',
                params: {
                  vaultId: vaultId
                }
              }));

            case 1:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28, this);
    }));
  };

  this.escape = function (vaultId, assetType, quantizedAmount) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
      return _regeneratorRuntime.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              return _context29.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkEscape',
                params: {
                  vaultId: vaultId,
                  assetType: assetType,
                  quantizedAmount: quantizedAmount
                }
              }));

            case 1:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29, this);
    }));
  };

  this.transfer = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              return _context30.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkTransfer',
                params: input
              }));

            case 1:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30, this);
    }));
  };

  this.transferEth = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
      return _regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              input.assetStandard = 'ETH';
              return _context31.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkTransfer',
                params: input
              }));

            case 2:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31, this);
    }));
  };

  this.transferErc20 = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
      return _regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              input.assetStandard = 'ERC20';
              return _context32.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkTransfer',
                params: input
              }));

            case 2:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, this);
    }));
  };

  this.transferErc721 = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              input.assetStandard = 'ERC721';
              return _context33.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkTransfer',
                params: input
              }));

            case 2:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33, this);
    }));
  };

  this.createOrder = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
      return _regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              return _context34.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkCreateOrder',
                params: input
              }));

            case 1:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34, this);
    }));
  };

  this.getAssetType = function (input) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
      return _regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              return _context35.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkAssetType',
                params: input
              }));

            case 1:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35, this);
    }));
  };

  this.getConditionHash = function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
      return _regeneratorRuntime.wrap(function _callee36$(_context36) {
        while (1) {
          switch (_context36.prev = _context36.next) {
            case 0:
              return _context36.abrupt("return", this.authereum._postMessageToChild({
                method: 'starkConditionHash',
                params: params
              }));

            case 1:
            case "end":
              return _context36.stop();
          }
        }
      }, _callee36, this);
    }));
  };

  this.signTransaction = function (tx) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
      return _regeneratorRuntime.wrap(function _callee37$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              return _context37.abrupt("return", this.authereum.signTransaction(tx));

            case 1:
            case "end":
              return _context37.stop();
          }
        }
      }, _callee37, this);
    }));
  };

  this.sendTransaction = function (tx) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
      return _regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) {
          switch (_context38.prev = _context38.next) {
            case 0:
              return _context38.abrupt("return", this.authereum.sendTransaction(tx));

            case 1:
            case "end":
              return _context38.stop();
          }
        }
      }, _callee38, this);
    }));
  };

  this.signMessage = function (msg, opts) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
      return _regeneratorRuntime.wrap(function _callee39$(_context39) {
        while (1) {
          switch (_context39.prev = _context39.next) {
            case 0:
              return _context39.abrupt("return", this.authereum.signMessage(msg, opts));

            case 1:
            case "end":
              return _context39.stop();
          }
        }
      }, _callee39, this);
    }));
  };

  this.signPersonalMessage = function (msg) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
      return _regeneratorRuntime.wrap(function _callee40$(_context40) {
        while (1) {
          switch (_context40.prev = _context40.next) {
            case 0:
              return _context40.abrupt("return", this.authereum.signPersonalMessage(msg));

            case 1:
            case "end":
              return _context40.stop();
          }
        }
      }, _callee40, this);
    }));
  };

  this.getAccountAddress = function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
      return _regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) {
          switch (_context41.prev = _context41.next) {
            case 0:
              return _context41.abrupt("return", this.authereum.getAccountAddress());

            case 1:
            case "end":
              return _context41.stop();
          }
        }
      }, _callee41, this);
    }));
  };

  this.estimateGas = function (tx) {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
      return _regeneratorRuntime.wrap(function _callee42$(_context42) {
        while (1) {
          switch (_context42.prev = _context42.next) {
            case 0:
              return _context42.abrupt("return", this.authereum.estimateGas(tx));

            case 1:
            case "end":
              return _context42.stop();
          }
        }
      }, _callee42, this);
    }));
  };

  this.authereum = authereum;
};

exports.default = StarkWareProvider;